import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AnalyticsCampaignData, AnalyticsData, AnalyticsTrackData, AnalyticsUserData } from 'models/Analytics';

export interface AnalyticsState {
  data: AnalyticsData;
}
export const initialState: AnalyticsState = {
  data: {
    page: {
      pageData: {
        sitePrefix: 'auspost:track',
        pageAbort: 'true',
      },
    },
    component: {
      track: {
        interaction: '',
        view: '',
      },
      ulp: {},
      search: {},
    },
    user: {
      userData: {},
    },
    campaign: {},
  },
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setView: (state, action: PayloadAction<string>) => {
      state.data.component.track.view = action.payload;
    },
    setTrackAnalytics: (state, action: PayloadAction<Partial<AnalyticsTrackData>>) => {
      state.data.component.track = {
        ...state.data.component.track,
        ...action.payload,
      };
    },
    setDialogCardAnalytics: (state, action: PayloadAction<string>) => {
      state.data.component.track.dialogCard = action.payload;
    },
    setDeliveryEstimateAnalytics: (state, action) => {
      state.data.component.track.estimatedDelivery = action.payload.analytics;
      state.data.component.track.flightStatus = action.payload.flightStatus as string;
    },
    setUserAnalytics: (state, action: PayloadAction<AnalyticsUserData>) => {
      state.data.user.userData = action.payload;
    },
    setCampaignAnalytics: (state, action: PayloadAction<AnalyticsCampaignData>) => {
      state.data.campaign = { campaignData: action.payload };
    },
  },
});

export const {
  setView,
  setTrackAnalytics,
  setCampaignAnalytics,
  setUserAnalytics,
  setDialogCardAnalytics,
  setDeliveryEstimateAnalytics,
} = analyticsSlice.actions;
